import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { PRODUCT_SLUG, config } from "../config";

export const DEFAULT_BRAND_INFO = {
  app_logo_url: "/idom_logo.webp",
  fav_icon_url: "/favicon.jpg",
  app_name: "iDoM",
  product_name: "Petty Cash",
  product_version: "v1.0.0",
  product_description:
    "Manage and track day to day business expenses with a simple petty cash system built for teams, approvals, and complete spending visibility.",
};

const fetchBrandInfo = async () => {
  const primaryBaseUrl = config.apiurl ? config.apiurl.replace(/\/+$/, "") : "";
  const primaryEndpoint = `${primaryBaseUrl}/get-app-and-product-version`;

  try {
    const response = await axios.get(primaryEndpoint, {
      params: { product_slug: PRODUCT_SLUG },
    });
    if (response?.data && typeof response.data === "object") {
      return {
        ...DEFAULT_BRAND_INFO,
        ...response.data,
      };
    }
    return DEFAULT_BRAND_INFO;
  } catch (primaryErr) {
    // Fallback to central production endpoint if current environment endpoint fails
    try {
      const fallbackResponse = await axios.get(
        "https://api.idom.in/get-app-and-product-version",
        {
          params: { product_slug: PRODUCT_SLUG },
        }
      );
      if (fallbackResponse?.data && typeof fallbackResponse.data === "object") {
        return {
          ...DEFAULT_BRAND_INFO,
          ...fallbackResponse.data,
        };
      }
    } catch (fallbackErr) {
      console.warn("Unable to fetch app and product version, using defaults", fallbackErr);
    }
    return DEFAULT_BRAND_INFO;
  }
};

export const useAppBrandInfo = () => {
  const query = useQuery(
    ["app-and-product-version", PRODUCT_SLUG],
    fetchBrandInfo,
    {
      staleTime: 60 * 60 * 1000, // 1 hour
      cacheTime: 24 * 60 * 60 * 1000, // 24 hours
      refetchOnWindowFocus: false,
      placeholderData: DEFAULT_BRAND_INFO,
    }
  );

  return query.data || DEFAULT_BRAND_INFO;
};

export default useAppBrandInfo;
